export default {
  tipos_instrumentos: [],
  tipo_instrumento: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
